// extracted by mini-css-extract-plugin
export default {"centered":"ChangePassword_centered__93T9g","centeredText":"ChangePassword_centeredText__LWoXB"};